import { DueBannerState } from 'modules/billing/store/models/Subscription'

import BlockingBanner from './BlockingBanner'
import NonBlockingBanner from './NonBlockingBanner'

interface Props {
  state: DueBannerState
  hasClockInSection: boolean
}

const UnpaidBanner = ({ state: { status, days_to_block }, hasClockInSection }: Props) => {
  switch (status) {
    case 'non_blocking':
      return <NonBlockingBanner days={days_to_block} />
    case 'blocking':
      return <BlockingBanner hasClockInSection={hasClockInSection} />
    default:
      return <></>
  }
}

export default UnpaidBanner
